var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdFiat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1161_14639)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 26C5.81994 26 0 20.1801 0 13C0 5.81994 5.81994 0 13 0C20.1801 0 26 5.81994 26 13C26 20.1801 20.1801 26 13 26ZM18.2812 15.5626C18.2812 13.5127 17.0007 12.3549 14.0051 11.6334V8.02588C14.9313 8.216 15.8177 8.61494 16.6847 9.24137L17.7889 7.45713C16.7013 6.6605 15.4238 6.16296 14.0839 6.01412V4.875H12.3695V5.97594C9.906 6.16606 8.23144 7.57087 8.23144 9.62081C8.23144 11.7658 9.57125 12.8099 12.4483 13.5314V17.2526C11.167 17.0625 10.1034 16.4929 8.97975 15.6195L7.71875 17.3469C9.06854 18.386 10.6768 19.0361 12.3695 19.227V21.125H14.0839V19.2457C16.5864 19.0369 18.2812 17.6507 18.2812 15.5626ZM12.4475 11.2344C10.9306 10.7981 10.5568 10.2854 10.5568 9.48756C10.5568 8.65312 11.2068 7.9885 12.4483 7.89344L12.4475 11.2344ZM15.9559 15.6951C15.9559 16.6067 15.2466 17.2331 14.0051 17.3282V13.8921C15.5423 14.3292 15.9559 14.8411 15.9559 15.6959V15.6951Z",
    fill: "#1C6C2A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1161_14639"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdFiat);
export default __webpack_public_path__ + "static/media/usd_fiat.a4c14d6f0c9741680e7ba034a594cc44.svg";
export { ForwardRef as ReactComponent };